export default {
  "brand.name": "USFansLink",
  "brand.tagline": "Spreadsheet Resource Hub",

  "nav.home": "Home",
  "nav.categories": "Categories",
  "nav.guides": "Guides",
  "nav.safety": "Safety",
  "nav.faq": "FAQ",
  "nav.buyNow": "Buy It Now",
  "nav.shoppingGuide": "Shopping Guide",
  "nav.language": "Language",

  "hero.eyebrow": "THE USFANS SPREADSHEET RESOURCE HUB",
  "hero.title": "USFans Spreadsheet — Find Products, Sellers & Useful Resources Faster",
  "hero.subtitle":
    "Explore USFans Spreadsheet resources, product guides, seller information, comparisons, reviews, shipping research and practical tutorials — all organized in one easy-to-use resource hub.",
  "hero.ctaSpreadsheet": "USFans Spreadsheet",
  "hero.ctaBuyNow": "Buy It Now",
  "hero.ctaBrowse": "Browse USFans Guides",
  "hero.trust": "Independent Resource • Updated Regularly • Multilingual",

  "categories.title": "Shop by Category",
  "categories.subtitle":
    "Jump straight to the products you care about. Every category opens on the main USFans Spreadsheet website.",

  "about.title": "What Is a USFans Spreadsheet?",
  "about.body":
    "A USFans Spreadsheet gathers product details, seller information, prices, shipping notes and other useful data into a single, easy-to-scan document. Instead of clicking through dozens of pages, you can compare items side by side, spot good deals and keep your research organized in one place.",
  "about.cta": "Explore the USFans Spreadsheet Guide",

  "benefits.title": "Everything You Need in One Place",
  "benefits.subtitle":
    "From product research to shipping checks, the USFans Spreadsheet helps you stay organized at every step.",

  "popular.title": "Popular Searches",
  "popular.subtitle": "The topics people search for most when researching USFans Spreadsheet.",

  "pillars.title": "USFans Spreadsheet Pillar Guides",
  "pillars.subtitle":
    "In-depth guides covering products, sellers, shipping, coupons, warehouse, safety and more — all in one place.",
  "pillars.readMore": "Read Article",

  "safety.title": "Research Smarter. Stay Safe.",
  "safety.body":
    "Always verify sellers, links, prices, shipping information and payment details independently before making any decision. A spreadsheet can help you organize information, but it should never replace your own careful checking.",
  "safety.cta": "Read Safety Guide",

  "faq.title": "Frequently Asked Questions",
  "faq.subtitle": "Quick answers to the most common questions about the USFans Spreadsheet.",

  "final.title": "Ready to Explore the USFans Spreadsheet?",
  "final.subtitle":
    "Browse the full product catalog, compare sellers and find what you need — all on the main USFans Spreadsheet website.",
  "final.explore": "Explore USFans Spreadsheet",
  "final.visit": "Visit Main Website",

  "footer.tagline":
    "USFansLink is an independent informational resource hub helping you research the USFans Spreadsheet — products, sellers, shipping and safety.",
  "footer.disclaimer":
    "USFansLink is an independent informational resource. Information can change over time. Always independently verify important information before making decisions.",
  "footer.quickLinks": "Quick Links",
  "footer.categories": "Categories",
  "footer.legal": "Legal",
  "footer.rights": "All rights reserved.",
};